// Checklist offline (Portaria > Checklist).

// Origem sincronizada por este app.
export const ORIGEM_TIPO = 'PORTARIA';

// Dias mantidos no dispositivo. Igual a DIAS_JANELA em FormularioRepository (API).
export const CHECKLIST_DIAS_JANELA = 60;

export const CHECKLIST_PARAMETROS = { fororigemtipo: ORIGEM_TIPO };
